<template>
  <div class='result-component result-text-component' :style='componentStyle'>
    <div v-if='config.image' class="result-image">
      <img :src='config.image'>
    </div>
    <header class='subheading' :style='headingStyle'>
      <h1>{{ $t(config.title, `options.components.${$attrs['data-index']}.options.title`) }}</h1>
    </header>
    <div class="wrapper">
      <section  :style='textStyle'>
        <div class="result-text" v-html='$t(config.text, `options.components.${$attrs["data-index"]}.options.text`)'>
        </div>
      </section>
    </div>
    <div class="comp-type" v-if='debugMode == true'>
      <slot name='comptype'></slot>
    </div>
  </div>
</template>
<script>
import TranslationMixin from '../lib/TranslationMixin'
export default {
  props: ['config', 'result'],
  mixins: [TranslationMixin],
  methods: {
    retargetLinks () {
      let links = this.$el.querySelectorAll('a')
      for (let link of links) {
        if (!link.href) {
          break
        }
        if (link.host !== location.host) {
          link.setAttribute('target', '_blank')
        }
      }
    }
  },
  computed: {
    stylesheet () {
      return this.$store.state.stylesheet
    },
    headingStyle () {
      return {
        fontSize: this.config.titleFontSize + '%'
      }
    },
    textStyle () {
      return {
        fontSize: this.config.textFontSize + '%'
      }
    },
    componentStyle () {
      let style = {
        backgroundColor: this.config.backgroundColor,
        color: this.config.textColor
      }
      return style
    }
  },
  mounted () {
    setTimeout(this.retargetLinks, 500)
  },
  created () {
    let styleRule = `#${this.$attrs.id} a:link, #${this.$attrs.id} a:visited`
    this.stylesheet.addRule(styleRule, {color: this.componentStyle.color})
  }
}
</script>
<style lang='scss'>

</style>
